import React from 'react'
import Grid from 'material-ui/Grid'
import Tabs, { Tab } from 'material-ui/Tabs'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import { connect } from 'react-redux';
import { compose } from 'recompose';

import withRole from '../hoc/role'
import {
  ROLES_CLIENT,
  ROLES_CLIENT_ADMIN_MANAGER
} from '../../common/constants'

import Title from '../ui/title'
import Content from '../ui/content'

import ProfileGeneral from './general'
import Organisation from './organisation'
import ResetPassword from './resetpassword'
import Privacy from './privacy'
import Preferences from './preferences'

const RoleBasedTab = withRole((props) => {
  return (<Tab {...props} />)
}, ROLES_CLIENT)

const RoleBasedOrganisation = withRole((props) => {
  return (<Organisation {...props} />)
}, ROLES_CLIENT)

class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: "profile"
    }
    this.handleTabChange = this.handleTabChange.bind(this)
  }
  handleTabChange(e, selectedTab) {
    this.setState({ selectedTab });
  }
  render() {
    const {
      translate,
      user,
      userUpdateAndList,
      customer,
      customerUpdate,
      passwordChange,
      languages,
      impersonating,
      removeLogo,
      profile,
      countryStates,
      softwareUpdate,
      getDataRequestSettings,
      submitDataRequest,
      smartFlagProfiles,
      checkArchive,
      classes,
    } = this.props

    const activeFeatures = this.props.activeFeatures;

    const {
      selectedTab,
    } = this.state

    let disableFields = false
    if (user && !ROLES_CLIENT_ADMIN_MANAGER.includes(user.roles[0])) {
      disableFields = true
    }
    const profileRoles = profile && profile.roles
      ? (Array.isArray(profile.roles) ? profile.roles : String(profile.roles).split(','))
        .map(role => String(role).trim().toLowerCase())
      : []
    const displayOrgTab = profileRoles.some(role => ["clientmanager", "clientuser", "clientadmin"].includes(role))
    const displayPreferencesTab = profileRoles.some(role => ["clientmanager", "clientadmin"].includes(role))
    const tabClasses = {
      root: classes.tab,
      labelContainer: classes.tabLabelContainer,
    }

    let margintop = "150px";

    if (impersonating && softwareUpdate) {
      margintop = "275px";
    } else if (impersonating || softwareUpdate) {
      margintop = "215px";
    }

    return (
      <div style={{marginTop: margintop}}>
        <Title title={translate("general_profile")} />
        <Content translate={translate}>
          <Grid container direction="row" justify="center">
            <Grid item xs={12} md={8} className={classes.tabsContainer}>
              <Tabs
                value={selectedTab}
                onChange={this.handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                scrollable
                scrollButtons="auto"
              >
                <Tab classes={tabClasses} value="profile" label={translate("profile_tab_profile")} />
                {displayOrgTab ? <RoleBasedTab classes={tabClasses} value="organisation" label={translate("profile_tab_organisation")} /> : null}
                {displayPreferencesTab ? <Tab classes={tabClasses} value="preferences" label={translate("profile_tab_preferences")} /> : null}
                <Tab classes={tabClasses} value="password" label={translate("profile_tab_password")} />
                <Tab classes={tabClasses} value="privacy" label={translate("profile_tab_privacy")} />

              </Tabs>
            </Grid>
            <Grid item xs={12} md={6}>
              {(selectedTab === "profile") && <ProfileGeneral user={user} update={userUpdateAndList} languages={languages} translate={translate} impersonating={impersonating} />}
              {(selectedTab === "password") && <ResetPassword update={passwordChange} translate={translate} impersonating={impersonating} />}
              {(selectedTab === "preferences") && <Preferences />}
              {(selectedTab === "organisation") &&
                <RoleBasedOrganisation languages={languages} customer={customer}
                                       countryStates={ countryStates } update={customerUpdate}
                                       translate={translate} impersonating={impersonating}
                                       removeLogo={removeLogo} disableFields={disableFields}
                                       smartFlagProfiles={smartFlagProfiles}
                                       activeFeatures={activeFeatures}
                                       checkArchive={checkArchive} />}
              {(selectedTab === "privacy") && <Privacy user={user} translate={translate} impersonating={impersonating} getSettings={getDataRequestSettings} submitRequest={submitDataRequest} />}

            </Grid>
          </Grid>
        </Content>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  impersonating: state.userReducer.impersonating,
  softwareUpdate: state.userReducer.softwareUpdate,
  ...state,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Profile);
